// extracted by mini-css-extract-plugin
export default {"Navbar":"Navbar_Navbar__zTaQb","Navbar__hero":"Navbar_Navbar__hero__Zpbit","Navbar__heroTechStack":"Navbar_Navbar__heroTechStack__qIrVX"};